import {PagewebPage} from './PagewebPage.enum';

export const pagewebPageUrlPatternMap: {
  [key in PagewebPage]: {
    pathQueryPattern: string;
    schemePattern: string;
  };
} = {
  [PagewebPage.Main]: {
    pathQueryPattern: '/',
    schemePattern: '/main',
  },
  [PagewebPage.OpenMain]: {
    pathQueryPattern: '/',
    schemePattern: '/open/main',
  },
  [PagewebPage.Viewer]: {
    pathQueryPattern: '/content/{series_id}/viewer/{product_id}',
    schemePattern: '/open/viewer?product_id={product_id}&series_id={series_id}',
  },
  [PagewebPage.Content]: {
    pathQueryPattern: '/content/{series_id}',
    schemePattern: '/open/content?series_id={series_id}',
  },
  [PagewebPage.SetOverview]: {
    pathQueryPattern: '/content/set-overview/{set_id}',
    schemePattern: '/open/content/set_overview?set_id={set_id}',
  },
  [PagewebPage.Subtab]: {
    pathQueryPattern: '/menu/{menu_uid}/screen/{screen_uid}',
    schemePattern: '/open/subtab?screen_uid={screen_uid}&menu_uid={menu_uid}',
  },
  [PagewebPage.InvenRecent]: {
    pathQueryPattern: '/inven/recent',
    schemePattern: '/open/inven/recent',
  },
  [PagewebPage.InvenLike]: {
    pathQueryPattern: '/inven/like',
    schemePattern: '/open/inven/like',
  },
  [PagewebPage.InvenPaid]: {
    pathQueryPattern: '/inven/paid',
    schemePattern: '/open/inven/paid',
  },
  [PagewebPage.MyNews]: {
    pathQueryPattern: '/mynews',
    schemePattern: '/open/mynews',
  },
  [PagewebPage.MyNewsWithTab]: {
    pathQueryPattern: '/mynews/{tab}',
    schemePattern: '/open/mynews?tab={tab}',
  },
  [PagewebPage.NoticeWithId]: {
    pathQueryPattern: '/notice/{notice_uid}',
    schemePattern: '/open/webview/notice?notice_uid={notice_uid}',
  },
  [PagewebPage.Notice]: {
    pathQueryPattern: '/notice',
    schemePattern: '/open/webview/notice',
  },
  [PagewebPage.AppStore]: {
    pathQueryPattern: '/appdownload',
    schemePattern: '/open/app/store',
  },
  [PagewebPage.CashHistory]: {
    pathQueryPattern: '/history/cash',
    schemePattern: '/open/webview/cash_history',
  },
  [PagewebPage.TicketHistory]: {
    pathQueryPattern: '/history/ticket',
    schemePattern: '/open/webview/ticket_history',
  },
  [PagewebPage.LandingSeriesList]: {
    pathQueryPattern: '/landing/series/list/{datakey}',
    schemePattern: '/open/landing/series/list?reference={datakey}',
  },
  [PagewebPage.LandingSingleList]: {
    pathQueryPattern: '/landing/single/list/{datakey}',
    schemePattern: '/open/landing/single/list?reference={datakey}',
  },
  [PagewebPage.LandingSeriesPoster]: {
    pathQueryPattern: '/landing/series/poster/{datakey}',
    schemePattern: '/open/landing/series/poster?reference={datakey}',
  },
  [PagewebPage.LandingSeriesListWithTheme]: {
    pathQueryPattern:
      '/landing/series/list/{datakey}/theme/{theme_keyword_uid}',
    schemePattern:
      '/open/landing/series/list?reference={datakey}&theme_keyword_uid={theme_keyword_uid}',
  },
  [PagewebPage.LandingSingleListWithTheme]: {
    pathQueryPattern:
      '/landing/single/list/{datakey}/theme/{theme_keyword_uid}',
    schemePattern:
      '/open/landing/single/list?reference={datakey}&theme_keyword_uid={theme_keyword_uid}',
  },
  [PagewebPage.LandingSeriesPosterWithTheme]: {
    pathQueryPattern:
      '/landing/series/poster/{datakey}/theme/{theme_keyword_uid}',
    schemePattern:
      '/open/landing/series/poster?reference={datakey}&theme_keyword_uid={theme_keyword_uid}',
  },
  [PagewebPage.LandingSetList]: {
    pathQueryPattern: '/landing/set/list/{datakey}',
    schemePattern: '/open/landing/set/list?reference={datakey}',
  },
  [PagewebPage.LandingSetPoster]: {
    pathQueryPattern: '/landing/set/poster/{datakey}',
    schemePattern: '/open/landing/set/poster?reference={datakey}',
  },
  [PagewebPage.LandingTodayUpSubcategory]: {
    pathQueryPattern: '/landing/today-up/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/landing/today_up?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.LandingTodayUp]: {
    pathQueryPattern: '/landing/today-up/{category_uid}',
    schemePattern: '/open/landing/today_up?category_uid={category_uid}',
  },
  [PagewebPage.LandingTodayNewSubcategory]: {
    pathQueryPattern: '/landing/today-new/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/landing/today_new?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.LandingTodayNew]: {
    pathQueryPattern: '/landing/today-new/{category_uid}',
    schemePattern: '/open/landing/today_new?category_uid={category_uid}',
  },
  [PagewebPage.LandingOriginalSubcategory]: {
    pathQueryPattern: '/landing/original/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/landing/original?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.LandingOriginal]: {
    pathQueryPattern: '/landing/original/{category_uid}',
    schemePattern: '/open/landing/original?category_uid={category_uid}',
  },
  [PagewebPage.LandingEvent]: {
    pathQueryPattern: '/landing/event/{category_uid}',
    schemePattern: '/open/landing/event?category_uid={category_uid}',
  },
  [PagewebPage.LandingEventTotal]: {
    pathQueryPattern: '/landing/event',
    schemePattern: '/open/landing/event',
  },
  [PagewebPage.LandingRankingSubcategory]: {
    pathQueryPattern: '/landing/ranking/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/landing/ranking?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.LandingRanking]: {
    pathQueryPattern: '/landing/ranking/{category_uid}',
    schemePattern: '/open/landing/ranking?category_uid={category_uid}',
  },
  [PagewebPage.LandingRankingTheme]: {
    pathQueryPattern: '/menu/{menu_uid}/screen/{screen_uid}',
    schemePattern:
      '/open/landing/ranking_theme?menu_uid={menu_uid}&screen_uid={screen_uid}',
  },
  [PagewebPage.LandingGenreSubcategory]: {
    pathQueryPattern: '/landing/genre/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/landing/genre?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.LandingGenre]: {
    pathQueryPattern: '/landing/genre/{category_uid}',
    schemePattern: '/open/landing/genre?category_uid={category_uid}',
  },
  [PagewebPage.DayofweekSubcategory]: {
    pathQueryPattern: '/landing/day-of-week/{category_uid}/{subcategory_uid}',
    schemePattern:
      '/open/day-of-week?category_uid={category_uid}&subcategory_uid={subcategory_uid}',
  },
  [PagewebPage.Dayofweek]: {
    pathQueryPattern: '/landing/day-of-week/{category_uid}',
    schemePattern: '/open/day-of-week?category_uid={category_uid}',
  },
  [PagewebPage.Freeseries]: {
    pathQueryPattern: '/landing/free-series/{category_uid}',
    schemePattern: '/open/freeseries?category_uid={category_uid}',
  },
  [PagewebPage.WebviewEvent]: {
    pathQueryPattern: '/event/{hash_uid}',
    schemePattern: '/open/webview/event?hash_uid={hash_uid}',
  },
  [PagewebPage.Gacha]: {
    pathQueryPattern: '/gacha?gacha_uid={gacha_uid}&map_uid={map_uid}',
    schemePattern:
      '/open/webview/gacha?gacha_uid={gacha_uid}&map_uid={map_uid}',
  },
  [PagewebPage.Redeem]: {
    pathQueryPattern: '/redeem',
    schemePattern: '/open/webview/redeem',
  },
  [PagewebPage.TodayGiftListWithCategory]: {
    pathQueryPattern: '/today-gift/category_uid',
    schemePattern: '/open/today_gift_list?category_uid={category_uid}',
  },
  [PagewebPage.TodayGiftList]: {
    pathQueryPattern: '/today-gift/0',
    schemePattern: '/open/today_gift_list',
  },
  [PagewebPage.CommentsDetail]: {
    pathQueryPattern:
      '/comment/detail?commentUid={comment_uid}&seriesId={series_id}',
    schemePattern:
      '/open/comments?series_id={series_id}&{comment_uid={comment_uid}',
  },
  [PagewebPage.Comments]: {
    pathQueryPattern: '/comment?seriesId={series_id}&productId={product_id}',
    schemePattern:
      '/open/comments?series_id={series_id}&product_id={product_id}',
  },
  [PagewebPage.BuyCash]: {
    pathQueryPattern: '/buy/cash',
    schemePattern: '/open/buy_cash',
  },
  [PagewebPage.BuyTicket]: {
    pathQueryPattern: '/buy/ticket?seriesId={series_id}',
    schemePattern: '/open/buy_ticket?series_id={series_id}',
  },
  [PagewebPage.Cashfriends]: {
    pathQueryPattern: '/cashfriends',
    schemePattern: '/open/webview/cashfriends',
  },
  /** @deprecated */
  [PagewebPage.KeytalkSearch]: {
    pathQueryPattern: '/keytalk-search/{category_uid}',
    schemePattern: '/open/keytalk/search?category_uid={category_uid}',
  },
  [PagewebPage.CashSponsor]: {
    pathQueryPattern: '/cashsponsor/{event_uid}',
    schemePattern: '/open/cash_sponsor?event_uid={event_uid}',
  },
  [PagewebPage.Autocharge]: {
    pathQueryPattern: '/relay/autocharge',
    schemePattern: '/open/webview/autocharge',
  },
  /** @deprecated */
  [PagewebPage.SearchKeytalk]: {
    pathQueryPattern:
      '/search/ai-keytalk?categoryUid={category_uid}&keytalkList={keytalk_list}',
    schemePattern:
      '/open/search/keytalk?category_uid={category_uid}&keytalk_list={keytalk_list}',
  },
  [PagewebPage.SearchFilter]: {
    pathQueryPattern: '/search/themekeyword?filterList={filter_list}',
    schemePattern: '/open/search/filter?filter_list={filter_list}',
  },
  [PagewebPage.SearchSeries]: {
    pathQueryPattern: '/search/result?keyword={text}',
    schemePattern: '/open/search/series?text={text}',
  },
  [PagewebPage.SearchMain]: {
    pathQueryPattern: '/search',
    schemePattern: '/open/search/main',
  },
  /** @deprecated */
  [PagewebPage.SpecialGift]: {
    pathQueryPattern: '/special-gift/reward/{gift_id}/{auid}',
    schemePattern: '/open/webview/special-gift?gift_id={gift_id}&auid={auid}',
  },
};
